/**
 * Sidepanel preview components
 */
import AsyncContactPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-1/components/AsyncContactPreviewSidepanel';
import AsyncContentPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-10/components/AsyncContentPreviewSidepanel';
import AsyncQuarantinedSubmissionSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-105/components/AsyncQuarantinedSubmissionSidepanel';
import AsyncFeedbackSurveyPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-111/components/AsyncFeedbackSurveyPreviewSidepanel';
import AsyncMarketingSMSPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-124/components/AsyncMarketingSMSPreviewSidepanel';
import AsyncExternalWebUrlPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-138/components/AsyncExternalWebUrlPreviewSidepanel';
import AsyncKnowledgeArticlePreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-151/components/AsyncKnowledgeArticlePreviewSidepanel';
import AsyncJourneyPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-158/components/AsyncJourneyPreviewSidepanel';
import AsyncFormPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-28/components/AsyncFormPreviewSidepanel';
import AsyncMarketingEmailPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-29/components/AsyncMarketingEmailPreviewSidepanel';
import AsyncDealPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-3/components/AsyncDealPreviewSidepanel';
import AsyncAdCampaignPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-31/components/AsyncAdCampaignPreviewSidepanel';
import AsyncCampaignPreviewModal from 'framework-asset-preview-lib/internal/objectTypes/0-35/components/AsyncCampaignPreviewModal';
import AsyncCampaignPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-35/components/AsyncCampaignPreviewSidepanel';
import AsyncSocialPostPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-37/components/AsyncSocialPostPreviewSidepanel';
import AsyncCtaPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-42/components/AsyncCtaPreviewSidepanel';
import AsyncWorkflowPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-44/components/AsyncWorkflowPreviewSidepanel';
import AsyncObjectListPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-45/components/AsyncObjectListPreviewSidepanel';
import AsyncTicketPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-5/components/AsyncTicketPreviewSidepanel';
import AsyncMarketingEventPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-54/components/AsyncMarketingEventPreviewSidepanel';
import AsyncMediaBridgePreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-57/components/AsyncMediaBridgePreviewSidepanel';
import AsyncSocialBroadcastPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-71/components/AsyncSocialBroadcastPreviewSidepanel';
import AsyncWhatsAppTemplatePreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-730/components/AsyncWhatsAppTemplatePreviewSidepanel';
import AsyncFileManagerFilePreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-77/components/AsyncFileManagerFilePreviewSidepanel';
import AsyncSalesDocumentPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-83/components/AsyncSalesDocumentPreviewSidepanel';
import AsyncWhatsAppPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-830/components/AsyncWhatsAppPreviewSidepanel';
import AsyncWebInteractivePreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-91/components/AsyncWebInteractivePreviewSidepanel';
import AsyncPlaybookPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/0-96/components/AsyncPlaybookPreviewSidepanel';
import AsyncGenericPreviewSidepanel from 'framework-asset-preview-lib/internal/objectTypes/GENERIC/components/AsyncGenericPreviewSidepanel';

/**
 * Sidebar preview components
 */
import AsyncMarketingEventPreviewSidebar from 'framework-asset-preview-lib/internal/objectTypes/0-54/components/AsyncMarketingEventPreviewSidebar';

/**
 * Popover preview components
 */
import AsyncContactPreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-1/components/AsyncContactPreviewPopover';
import AsyncContentPreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-10/components/AsyncContentPreviewPopover';
import AsyncFeedbackSurveyPreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-111/components/AsyncFeedbackSurveyPreviewPopover';
import AsyncMarketingSMSPreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-124/components/AsyncMarketingSMSPreviewPopover';
import AsyncKnowledgeArticlePreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-151/components/AsyncKnowledgeArticlePreviewPopover';
import AsyncSalesTaskPreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-27/components/AsyncSalesTaskPreviewPopover';
import AsyncFormPreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-28/components/AsyncFormPreviewPopover';
import AsyncMarketingEmailPreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-29/components/AsyncMarketingEmailPreviewPopover';
import AsyncDealPreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-3/components/AsyncDealPreviewPopover';
import AsyncAdCampaignPreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-31/components/AsyncAdCampaignPreviewPopover';
import AsyncAdGroupPreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-32/components/AsyncAdGroupPreviewPopover';
import AsyncCampaignPreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-35/components/AsyncCampaignPreviewPopover';
import AsyncSocialPostPreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-37/components/AsyncSocialPostPreviewPopover';
import AsyncObjectListPreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-45/components/AsyncObjectListPreviewPopover';
import AsyncMeetingEventPopover from 'framework-asset-preview-lib/internal/objectTypes/0-47/components/AsyncMeetingEventPopover';
import AsyncCallPopover from 'framework-asset-preview-lib/internal/objectTypes/0-48/components/AsyncCallPopover';
import AsyncSalesEmailPopover from 'framework-asset-preview-lib/internal/objectTypes/0-49/components/AsyncSalesEmailPopover';
import AsyncTicketPreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-5/components/AsyncTicketPreviewPopover';
import AsyncPublishingTaskPreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-50/components/AsyncPublishingTaskPreviewPopover';
import AsyncMarketingEventPopover from 'framework-asset-preview-lib/internal/objectTypes/0-54/components/AsyncMarketingEventPopover';
import AsyncMediaBridgePreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-57/components/AsyncMediaBridgePreviewPopover';
import AsyncSocialBroadcastPreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-71/components/AsyncSocialBroadcastPreviewPopover';
import AsyncFileManagerFilePreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-77/components/AsyncFileManagerFilePreviewPopover';
import AsyncSalesDocumentPopover from 'framework-asset-preview-lib/internal/objectTypes/0-83/components/AsyncSalesDocumentPopover';
import AsyncPlaybookPopover from 'framework-asset-preview-lib/internal/objectTypes/0-96/components/AsyncPlaybookPopover';
import AsyncWhatsAppTemplatePreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/0-730/components/AsyncWhatsAppTemplatePreviewPopover';
import AsyncGenericPreviewPopover from 'framework-asset-preview-lib/internal/objectTypes/GENERIC/components/AsyncGenericPreviewPopover';

/**
 * Card preview components
 */
import AsyncMarketingSMSPreviewCard from 'framework-asset-preview-lib/internal/objectTypes/0-124/components/AsyncMarketingSMSPreviewCard';
import AsyncCampaignPreviewCard from 'framework-asset-preview-lib/internal/objectTypes/0-35/components/AsyncCampaignPreviewCard';
import AsyncCtaPreviewCard from 'framework-asset-preview-lib/internal/objectTypes/0-42/components/AsyncCtaPreviewCard';
import AsyncWebInteractivePreviewCard from 'framework-asset-preview-lib/internal/objectTypes/0-91/components/AsyncWebInteractivesPreviewCard';
import AsyncGenericPreviewCard from 'framework-asset-preview-lib/internal/objectTypes/GENERIC/components/AsyncGenericPreviewCard';

/**
 * Carousel preview components
 */
import AsyncGenericCarouselPreview from 'framework-asset-preview-lib/internal/objectTypes/GENERIC/components/AsyncGenericCarouselPreview';

/**
 * Object status components
 */
import AsyncMarketingSmsStatus from 'framework-asset-preview-lib/internal/objectTypes/0-124/components/AsyncMarketingSmsStatus';
import AsyncMarketingEventStatus from 'framework-asset-preview-lib/internal/objectTypes/0-54/components/AsyncMarketingEventStatus';
import AsyncWhatsAppStatusTag from 'framework-asset-preview-lib/internal/objectTypes/0-830/components/DisplayStatus/AsyncWhatsAppStatusTag';

/**
 * Image preview components
 */
import AsyncContentImagePreview from 'framework-asset-preview-lib/internal/objectTypes/0-10/components/AsyncContentImagePreview';
import AsyncMarketingSMSImagePreview from 'framework-asset-preview-lib/internal/objectTypes/0-124/components/AsyncMarketingSMSImagePreview';
import AsyncWhatsAppImagePreview from 'framework-asset-preview-lib/internal/objectTypes/0-830/components/AsyncWhatsAppImagePreview';
import AsyncWhatsAppTemplateImagePreview from 'framework-asset-preview-lib/internal/objectTypes/0-730/components/AsyncWhatsAppTemplateImagePreview';
import AsyncFormImagePreview from 'framework-asset-preview-lib/internal/objectTypes/0-28/components/AsyncFormImagePreview';
import AsyncMarketingEmailImagePreview from 'framework-asset-preview-lib/internal/objectTypes/0-29/components/AsyncMarketingEmailImagePreview';
import AsyncCtaImagePreview from 'framework-asset-preview-lib/internal/objectTypes/0-42/components/AsyncCtaImagePreview';
import AsyncMediaBridgeImagePreview from 'framework-asset-preview-lib/internal/objectTypes/0-57/components/AsyncMediaBridgeImagePreview';
import AsyncSocialBroadcastImagePreview from 'framework-asset-preview-lib/internal/objectTypes/0-71/components/AsyncSocialBroadcastImagePreview';
import AsyncFileManagerFileImagePreview from 'framework-asset-preview-lib/internal/objectTypes/0-77/components/AsyncFileManagerFileImagePreview';
import AsyncSalesDocumentImagePreview from 'framework-asset-preview-lib/internal/objectTypes/0-83/components/AsyncSalesDocumentImagePreview';
import AsyncWebInteractivesImagePreview from 'framework-asset-preview-lib/internal/objectTypes/0-91/components/AsyncWebInteractivesImagePreview';
import { OBJECT_TYPE } from 'framework-asset-preview-lib/internal/shared/constants/objectTypes';
export const SIDEPANEL_COMPONENTS = {
  [OBJECT_TYPE.CONTENT]: AsyncContentPreviewSidepanel,
  [OBJECT_TYPE.LANDING_PAGE]: AsyncContentPreviewSidepanel,
  [OBJECT_TYPE.FORM]: AsyncFormPreviewSidepanel,
  [OBJECT_TYPE.MARKETING_EMAIL]: AsyncMarketingEmailPreviewSidepanel,
  [OBJECT_TYPE.AD_CAMPAIGN]: AsyncAdCampaignPreviewSidepanel,
  [OBJECT_TYPE.CAMPAIGN]: AsyncCampaignPreviewSidepanel,
  [OBJECT_TYPE.SITE_PAGE]: AsyncContentPreviewSidepanel,
  [OBJECT_TYPE.BLOG_POST]: AsyncContentPreviewSidepanel,
  [OBJECT_TYPE.CTA]: AsyncCtaPreviewSidepanel,
  [OBJECT_TYPE.WORKFLOW]: AsyncWorkflowPreviewSidepanel,
  [OBJECT_TYPE.SOCIAL_BROADCAST]: AsyncSocialBroadcastPreviewSidepanel,
  [OBJECT_TYPE.WEB_INTERACTIVE]: AsyncWebInteractivePreviewSidepanel,
  [OBJECT_TYPE.QUARANTINED_SUBMISSION]: AsyncQuarantinedSubmissionSidepanel,
  [OBJECT_TYPE.OBJECT_LIST]: AsyncObjectListPreviewSidepanel,
  [OBJECT_TYPE.MARKETING_EVENT]: AsyncMarketingEventPreviewSidepanel,
  [OBJECT_TYPE.MARKETING_SMS]: AsyncMarketingSMSPreviewSidepanel,
  [OBJECT_TYPE.EXTERNAL_WEB_URL]: AsyncExternalWebUrlPreviewSidepanel,
  [OBJECT_TYPE.AUTOMATION_JOURNEY]: AsyncJourneyPreviewSidepanel,
  [OBJECT_TYPE.SALES_DOCUMENT]: AsyncSalesDocumentPreviewSidepanel,
  [OBJECT_TYPE.PLAYBOOK]: AsyncPlaybookPreviewSidepanel,
  [OBJECT_TYPE.FILE_MANAGER_FILE]: AsyncFileManagerFilePreviewSidepanel,
  [OBJECT_TYPE.MEDIA_BRIDGE]: AsyncMediaBridgePreviewSidepanel,
  [OBJECT_TYPE.KNOWLEDGE_ARTICLE]: AsyncKnowledgeArticlePreviewSidepanel,
  [OBJECT_TYPE.FEEDBACK_SURVEY]: AsyncFeedbackSurveyPreviewSidepanel,
  [OBJECT_TYPE.TICKET]: AsyncTicketPreviewSidepanel,
  [OBJECT_TYPE.SOCIAL_POST]: AsyncSocialPostPreviewSidepanel,
  [OBJECT_TYPE.DEAL]: AsyncDealPreviewSidepanel,
  [OBJECT_TYPE.CONTACT]: AsyncContactPreviewSidepanel,
  [OBJECT_TYPE.WHATSAPP]: AsyncWhatsAppPreviewSidepanel,
  [OBJECT_TYPE.WHATSAPP_TEMPLATE]: AsyncWhatsAppTemplatePreviewSidepanel
};
export function getSidepanelPreview(objectTypeId) {
  if (objectTypeId in SIDEPANEL_COMPONENTS) {
    return SIDEPANEL_COMPONENTS[objectTypeId];
  }
  return AsyncGenericPreviewSidepanel;
}
const MODAL_COMPONENTS = {
  [OBJECT_TYPE.CAMPAIGN]: AsyncCampaignPreviewModal
};
export function getModalPreview(objectTypeId) {
  if (objectTypeId in MODAL_COMPONENTS) {
    return MODAL_COMPONENTS[objectTypeId];
  }
  return null;
}
const POPOVER_COMPONENTS = {
  [OBJECT_TYPE.AD_CAMPAIGN]: AsyncAdCampaignPreviewPopover,
  [OBJECT_TYPE.AD_GROUP]: AsyncAdGroupPreviewPopover,
  [OBJECT_TYPE.BLOG_POST]: AsyncContentPreviewPopover,
  [OBJECT_TYPE.CAMPAIGN]: AsyncCampaignPreviewPopover,
  [OBJECT_TYPE.CONTACT]: AsyncContactPreviewPopover,
  [OBJECT_TYPE.FORM]: AsyncFormPreviewPopover,
  [OBJECT_TYPE.LANDING_PAGE]: AsyncContentPreviewPopover,
  [OBJECT_TYPE.MARKETING_EMAIL]: AsyncMarketingEmailPreviewPopover,
  [OBJECT_TYPE.MARKETING_EVENT]: AsyncMarketingEventPopover,
  [OBJECT_TYPE.MARKETING_SMS]: AsyncMarketingSMSPreviewPopover,
  [OBJECT_TYPE.WHATSAPP_TEMPLATE]: AsyncWhatsAppTemplatePreviewPopover,
  [OBJECT_TYPE.OBJECT_LIST]: AsyncObjectListPreviewPopover,
  [OBJECT_TYPE.PUBLISHING_TASK]: AsyncPublishingTaskPreviewPopover,
  [OBJECT_TYPE.SITE_PAGE]: AsyncContentPreviewPopover,
  [OBJECT_TYPE.SOCIAL_BROADCAST]: AsyncSocialBroadcastPreviewPopover,
  [OBJECT_TYPE.TASK]: AsyncSalesTaskPreviewPopover,
  [OBJECT_TYPE.SALES_DOCUMENT]: AsyncSalesDocumentPopover,
  [OBJECT_TYPE.PLAYBOOK]: AsyncPlaybookPopover,
  [OBJECT_TYPE.EMAIL]: AsyncSalesEmailPopover,
  [OBJECT_TYPE.CALL]: AsyncCallPopover,
  [OBJECT_TYPE.MEETING_EVENT]: AsyncMeetingEventPopover,
  [OBJECT_TYPE.FILE_MANAGER_FILE]: AsyncFileManagerFilePreviewPopover,
  [OBJECT_TYPE.MEDIA_BRIDGE]: AsyncMediaBridgePreviewPopover,
  [OBJECT_TYPE.KNOWLEDGE_ARTICLE]: AsyncKnowledgeArticlePreviewPopover,
  [OBJECT_TYPE.FEEDBACK_SURVEY]: AsyncFeedbackSurveyPreviewPopover,
  [OBJECT_TYPE.TICKET]: AsyncTicketPreviewPopover,
  [OBJECT_TYPE.SOCIAL_POST]: AsyncSocialPostPreviewPopover,
  [OBJECT_TYPE.DEAL]: AsyncDealPreviewPopover
};
export function getPopoverPreview(objectTypeId) {
  if (objectTypeId in POPOVER_COMPONENTS) {
    return POPOVER_COMPONENTS[objectTypeId];
  }
  return AsyncGenericPreviewPopover;
}
const SIDEBAR_COMPONENTS = {
  [OBJECT_TYPE.MARKETING_EVENT]: AsyncMarketingEventPreviewSidebar
};

/**
 * Return a sidebar component (when defined), otherwise fallback to sidepanel preview
 */
export function getSidebarPreview(objectTypeId) {
  if (objectTypeId in SIDEBAR_COMPONENTS) {
    return SIDEBAR_COMPONENTS[objectTypeId];
  }
  return getSidepanelPreview(objectTypeId);
}
const CARD_COMPONENTS = {
  [OBJECT_TYPE.CAMPAIGN]: AsyncCampaignPreviewCard,
  [OBJECT_TYPE.CTA]: AsyncCtaPreviewCard,
  [OBJECT_TYPE.WEB_INTERACTIVE]: AsyncWebInteractivePreviewCard,
  [OBJECT_TYPE.MARKETING_SMS]: AsyncMarketingSMSPreviewCard
};
export function getCardPreview(objectTypeId) {
  if (objectTypeId in CARD_COMPONENTS) {
    return CARD_COMPONENTS[objectTypeId];
  }
  return AsyncGenericPreviewCard;
}
export function getCarouselPreview() {
  return AsyncGenericCarouselPreview;
}
const STATUS_COMPONENTS = {
  [OBJECT_TYPE.MARKETING_EVENT]: AsyncMarketingEventStatus,
  [OBJECT_TYPE.MARKETING_SMS]: AsyncMarketingSmsStatus,
  [OBJECT_TYPE.WHATSAPP]: AsyncWhatsAppStatusTag
};
export function getObjectStatus(objectTypeId) {
  return STATUS_COMPONENTS[objectTypeId];
}
const IMAGE_PREVIEW_COMPONENTS = {
  [OBJECT_TYPE.CONTENT]: AsyncContentImagePreview,
  [OBJECT_TYPE.BLOG_POST]: AsyncContentImagePreview,
  [OBJECT_TYPE.LANDING_PAGE]: AsyncContentImagePreview,
  [OBJECT_TYPE.SITE_PAGE]: AsyncContentImagePreview,
  [OBJECT_TYPE.MARKETING_EMAIL]: AsyncMarketingEmailImagePreview,
  [OBJECT_TYPE.CTA]: AsyncCtaImagePreview,
  [OBJECT_TYPE.SOCIAL_BROADCAST]: AsyncSocialBroadcastImagePreview,
  [OBJECT_TYPE.WEB_INTERACTIVE]: AsyncWebInteractivesImagePreview,
  [OBJECT_TYPE.MARKETING_SMS]: AsyncMarketingSMSImagePreview,
  [OBJECT_TYPE.WHATSAPP]: AsyncWhatsAppImagePreview,
  [OBJECT_TYPE.WHATSAPP_TEMPLATE]: AsyncWhatsAppTemplateImagePreview,
  [OBJECT_TYPE.FORM]: AsyncFormImagePreview,
  [OBJECT_TYPE.SALES_DOCUMENT]: AsyncSalesDocumentImagePreview,
  [OBJECT_TYPE.FILE_MANAGER_FILE]: AsyncFileManagerFileImagePreview,
  [OBJECT_TYPE.MEDIA_BRIDGE]: AsyncMediaBridgeImagePreview
};
export function getObjectImagePreview(objectTypeId) {
  return IMAGE_PREVIEW_COMPONENTS[objectTypeId];
}